/**
 * Web-safe slug from a human-readable name. German umlauts get expanded
 * (ä→ae, ö→oe, ü→ue, ß→ss); everything that isn't [a-z0-9] becomes "-";
 * consecutive dashes collapse and leading/trailing dashes are trimmed.
 * Capped at 64 chars to match the server-side SlugSchema.
 *
 * Examples:
 *   "Generator für Zertifikate" → "generator-fuer-zertifikate"
 *   "Über Uns"                  → "ueber-uns"
 *   "App! v2"                   → "app-v2"
 */
const UMLAUT_MAP: Array<[string, string]> = [
  ["ä", "ae"],
  ["ö", "oe"],
  ["ü", "ue"],
  ["ß", "ss"],
  ["Ä", "Ae"],
  ["Ö", "Oe"],
  ["Ü", "Ue"],
];

export function slugFromName(name: string): string {
  let s = name;
  for (const [from, to] of UMLAUT_MAP) {
    s = s.split(from).join(to);
  }
  return s
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 64);
}
